import { render, staticRenderFns } from "./ChooseUs.vue?vue&type=template&id=4563a151"
import script from "./ChooseUs.vue?vue&type=script&lang=js"
export * from "./ChooseUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports